import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'

export interface RefEquipmentItem {
  item_key: string
  item_name: string
  weight_lbs: number | null
  value_denarii: number | null
  is_container: boolean
  is_consumable: boolean
  capacity: number | null
  category: string
  notes: string | null
}

export function useRefEquipment() {
  return useQuery({
    queryKey: ['ref_equipment'],
    queryFn: async () => {
      const { data, error } = await supabase.from('ref_equipment').select('*').order('category').order('item_name')
      if (error) throw error
      return data as RefEquipmentItem[]
    },
    staleTime: Infinity,
  })
}
